<af-main-container #mainContainerComponent
                   [title]="'i18n_af_msisdnDetailsTitle' | translate:{msisdnId: msisdnId}"
                   spinnerIds="initial"
                   [queryParamsHandling]="'merge'"
                   [breadcrumbCustomizer]="breadcrumbCustomizer"
                   filterNavigationPath="msisdn"
                   [enableScroll]="false"
                   [buttonLabel]="canDelete ? ('i18n_af_buttonDelete' | translate) : null"
                   buttonSpinnerId="deleting"
                   (buttonClickListener)="openDeleteDialog()"
                   class="w-100 h-100">
    @if (msisdn) {
        <div class="container">
            <div class="details-container" fxLayout="column" fxLayoutAlign="start start">
                <div class="t2-semi-bold c-main-gray-900">{{ 'i18n_af_msisdnDataLabel' | translate }}</div>
                <div class="info-container">
                    @for (field of msisdnFields; track field) {
                        <div class="t2 c-primary-gray-600">{{ 'i18n_af_msisdn_field#' + field.fieldName | translate }}</div>
                        <div class="t2 c-primary-gray-900">{{ field.fieldValue }}</div>
                    }
                </div>
            </div>
            <div class="details-container" fxLayout="column" fxLayoutAlign="start start">
                <div class="t2-semi-bold c-main-gray-900">{{ 'i18n_af_msisdnAuthorDataLabel' | translate }}</div>
                <div class="info-container">
                    @for (field of authorFields; track field) {
                        <div class="t2 c-primary-gray-600">{{ 'i18n_af_msisdn_field#' + field.fieldName | translate }}</div>
                        <div class="t2 c-primary-gray-900">{{ field.fieldValue }}</div>
                    }
                </div>
            </div>
        </div>
        <mat-tab-group mat-align-tabs="start" animationDuration="0"
                       [(selectedIndex)]="selectedTabIndex"
                       (selectedIndexChange)="handleNavigation($event)"
                       class="mt-16 w-100 h-100 hide-scroll-bar">
            @for (tab of tabs; track tab) {
                <mat-tab [label]="'i18n_af_msisdn_tab#' + tab | translate" class="text-center h-100">
                    <ng-template matTabContent>
                        @if (activeTab === tab) {
                            <af-full-table fxFlex
                                class="mt-24"
                                [dataSource]="dataSource"
                                [showPaginator]="false"
                                emptyStateIconName="ic_empty_state_no_data"
                                emptyStateTitleTranslationKey="i18n_af_emptyStateTitleNoData"
                                emptyStateSubtitleTranslationKey="i18n_af_emptyStateSubtitleNoData"/>
                        }
                    </ng-template>
                </mat-tab>
            }
        </mat-tab-group>
    }
</af-main-container>
